import { AlertCircle, ArrowLeft, Home } from 'lucide-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {}, [location.pathname]);

  return (
    <div className='flex min-h-screen items-center justify-center bg-background'>
      <div className='text-center space-y-6 p-6 max-w-md mx-auto'>
        {/* Error Icon */}
        <div className='w-20 h-20 mx-auto bg-destructive/10 rounded-full flex items-center justify-center'>
          <AlertCircle className='w-10 h-10 text-destructive' />
        </div>

        {/* Error Text */}
        <div className='space-y-2'>
          <h1 className='text-6xl font-bold text-foreground'>404</h1>
          <h2 className='text-2xl font-semibold text-foreground'>Page Not Found</h2>
          <p className='text-muted-foreground'>
            Sorry, the page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
        </div>

        {/* Route Info */}
        <div className='bg-muted/50 p-3 rounded-lg'>
          <p className='text-sm text-muted-foreground'>
            Attempted to access:{' '}
            <code className='font-mono text-foreground'>{location.pathname}</code>
          </p>
        </div>

        {/* Action Buttons */}
        <div className='flex flex-col sm:flex-row gap-3 justify-center'>
          <Button
            onClick={() => navigate(-1)}
            variant='outline'
            className='flex items-center gap-2'
          >
            <ArrowLeft className='w-4 h-4' />
            Go Back
          </Button>
          <Button onClick={() => navigate('/dashboard')} className='flex items-center gap-2'>
            <Home className='w-4 h-4' />
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
